import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import OnboardingStepsTableActions from '@/components/onboarding/OnboardingStepsTableActions.vue';
import OnboardingTableFilesDownload from '@/components/onboarding/OnboardingTableFilesDownload.vue';
import TableStatusSelect from '@/components/onboarding/TableStatusSelect.vue';
import type { OnboardingStep } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<OnboardingStep>[] = [
    {
        accessorKey: 'order',
        enableColumnFilter: false,
    },
    {
        accessorKey: 'title',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'onboarding.table.service',
            }),
    },
    {
        accessorKey: 'description_translated',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'onboarding.table.description',
            }),
    },
    {
        accessorKey: 'status',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'onboarding.table.status',
            }),
        cell: ({ row }) => {
            return h(TableStatusSelect, {
                key: row.original.id + '-' + row.original.status,
                modelValue: row.original.status,
                onboardingStepId: row.original.id,
            });
        },
    },
    {
        accessorKey: 'comment',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'onboarding.table.comment',
            }),
    },
    {
        accessorKey: 'existing_files',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'onboarding.table.files',
            }),
        cell: ({ row }) => {
            return h(OnboardingTableFilesDownload, {
                companyOnboardingStep: row.original,
                files: row.original.existing_files,
            });
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employee.table.actions',
            }),
        cell: ({ row, table }) => {
            return h(OnboardingStepsTableActions, {
                onboardingStep: row.original,
                table: table,
            });
        },
    },
];
